import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { UsuarioFranquiaAppRoutingModule } from "./usuario-franquia.app-routing.module";
import { UsuarioFranquiaListarComponent } from "./usuario-franquia-listar/usuario-franquia-listar.component";
import { FormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { DividerModule } from "primeng/divider";
import { InputTextModule } from "primeng/inputtext";
import { DialogModule } from "primeng/dialog";
import { TreeTableModule } from "primeng/treetable";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { TooltipModule } from "primeng/tooltip";
import { UsuarioFranquiaEditarComponent } from "./usuario-franquia-editar/usuario-franquia-editar.component";
import { MessagesModule } from "primeng/messages";
import { FormatPipeModule } from "src/app/admihair/format-pipe/format-pipe.module";
import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { UsuarioFranquiaDetalharComponent } from "./usuario-franquia-detalhar/usuario-franquia-detalhar.component";
import { UsuarioFranquiaInserirComponent } from "./usuario-franquia-inserir/usuario-franquia-inserir.component";
import { DropdownModule } from "primeng/dropdown";
import { InputMaskModule } from "primeng/inputmask";

@NgModule({
    imports: [
        CommonModule,
        UsuarioFranquiaAppRoutingModule,
        FormsModule,
        TableModule,
        ButtonModule,
        InputTextModule,
        DividerModule,
        DialogModule,
        TreeTableModule,
        ProgressSpinnerModule,
        TooltipModule,
        MessagesModule,
        FormatPipeModule,
        ConfirmDialogModule,
        DropdownModule,
        InputMaskModule
        
    ],
    declarations: [
        UsuarioFranquiaListarComponent,
        UsuarioFranquiaEditarComponent,
        UsuarioFranquiaDetalharComponent,
        UsuarioFranquiaInserirComponent
    ],
    providers: [ConfirmationService]
})
export class UsuarioFranquiaAppModule { }
